import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Never give up",
  "description": "",
  "published": "2018-12-14T00:00:00.000Z",
  "redirect_from": ["/blog/never-give-up/swizec/8816"],
  "categories": "Personal, Travel + Events",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`A fun and ridiculous story I wanted to share.`}</p>
    <p>{`-`}{`- San Francisco, 7am`}</p>
    <p><em parentName="p">{`"Be right there guys, just making some tea.”`}</em></p>
    <p>{`I just rolled out of bed. Late for my mastermind call. Again.`}</p>
    <p>{`Four of us get together on gHangouts every other Thursday at 7am. I'm late every time. 7am is way too early. But it's the only time everyone can make it.`}</p>
    <p>{`We often skip weeks.`}</p>
    <p>{`Thorben was in the hot seat today. He just launched a new beginners course for a Java framework. Hibernate or something.`}</p>
    <p>{`I envy those Java guys. Their tech changes at a glacial pace compared to the JavaScript world. We talked about that as well.`}</p>
    <p>{`-`}{`- San Francisco, 9am`}</p>
    <p>{`I open iA Writer. Just enough time to write an article for `}<a parentName="p" {...{
        "href": "https://reactviz.holiday/candy/"
      }}>{`ReactViz.Holiday Day 9`}</a>{` about declarative transitions with React and D3 and why you need to use `}<inlineCode parentName="p">{`Math.random()`}</inlineCode>{` to make your animation look natural.`}</p>
    <p>{`Did you know Americans spend more than $800,000,000 on candy for Easter? Crazy.`}</p>
    <p>{`-`}{`- San Francisco, 9:45am`}</p>
    <p><em parentName="p">{`"You should pack"`}</em></p>
    <p>{`steam comes out of my ears`}</p>
    <p><em parentName="p">{`"Okay then. Do you want something from Starbucks?"`}</em></p>
    <p>{`aaaa stop talking I'm trying to focus can't you see I have to finish this before I can start packing`}</p>
    <p>{`-`}{`- San Francisco, 10:05am`}</p>
    <p>{`A wild chai appears. My girlfriend knows me very well ❤️`}</p>
    <p>{`-`}{`- San Francisco, 10:45am`}</p>
    <p>{`Article done. Shipped off to Will the editor. He'll turn it into an email, put it up on Facebook, give it a little boost.`}</p>
    <p>{`I used Twitter to host some videos. We can't figure out how to get gifs to work in MDX on Gatsby. That took care of the Twitter share. Two birds one stone!`}</p>
    <blockquote {...{
      "className": "twitter-tweet",
      "data-dnt": "true"
    }}><p parentName="blockquote" {...{
        "lang": "en",
        "dir": "ltr"
      }}>{`Here's why adding randomness to your animations matters 👇`}<br parentName="p"></br><br parentName="p"></br>{`This chart of candy buying habits in the US is not random at all. Delay based purely on array index. `}<a parentName="p" {...{
          "href": "https://t.co/pTTWxovaSp"
        }}>{`pic.twitter.com/pTTWxovaSp`}</a></p>{`— Swizec Teller published ServerlessHandbook.dev (@Swizec) `}<a parentName="blockquote" {...{
        "href": "https://twitter.com/Swizec/status/1073285327282876416"
      }}>{`December 13, 2018`}</a></blockquote>
    <p>{`-`}{`- San Francisco, 11:05am`}</p>
    <p>{`Ah crap, why'd I agree to a meeting today? That was dumb. Agh now I don't have time to pack. Should I take the bike? No, too much overhead. Uber? Aaah waiting will stress me out too much. I'll just walk. It's only a mile.`}</p>
    <p>{`-`}{`- San Francisco, 11:30am`}</p>
    <p><em parentName="p">{`"Hey Guillermo, I'm having some trouble finding your office.”`}</em></p>
    <p>{`Meeting up with the Zeit team was fun. I love their now-cli tool, and it was foolish to agree to meet up today, but I was curious what they wanted to chat about.`}</p>
    <p>{`This could be the start of something beautiful. Or it could be nothing. You never know.`}</p>
    <p>{`-`}{`- San Francisco, 12:45pm`}</p>
    <p>{`Girlfriend brings salads! Yay`}</p>
    <p>{`She was right. We never would've made brunch. How did I think that was gonna work out?`}</p>
    <p>{`Flight leaves in 3 hours. Good thing it's delayed. Still haven't packed.`}</p>
    <blockquote {...{
      "className": "twitter-tweet",
      "data-dnt": "true"
    }}><p parentName="blockquote" {...{
        "lang": "en",
        "dir": "ltr"
      }}>{`Flight to Europe in 3 hours. Still gotta pack 😅`}<br parentName="p"></br><br parentName="p"></br>{`What do you think I’ll forget?`}</p>{`— Swizec Teller published ServerlessHandbook.dev (@Swizec) `}<a parentName="blockquote" {...{
        "href": "https://twitter.com/Swizec/status/1073314375350382593"
      }}>{`December 13, 2018`}</a></blockquote>
    <p>{`Asking Twitter what they think I'd forget worked perfectly. The hive mind reminded me of everything I would have forgotten.`}</p>
    <p>{`Missed my 5-minute journal though :(`}</p>
    <p>{`Packed for 2 weeks of Europe in one backpack and one suitcase. Great success! Half the suitcase is Christmas presents. 👌`}</p>
    <p>{`-`}{`- San Francisco, 1:42pm`}</p>
    <p>{`Boarding starts in 60 minutes. Uber says I'll be at airport in 38 minutes.`}</p>
    <p>{`We got dis! 💪`}</p>
    <p>{`-`}{`- Oakland, 2:11pm`}</p>
    <p>{`Woo made it! Plenty of time to spare. Flight isn't even until 3:50pm.`}</p>
    <p><em parentName="p">{`"Sir, your suitcase is too heavy"`}</em></p>
    <p>{`My what now?`}</p>
    <p><em parentName="p">{`"You're 7 kilo over. It's `}{`\\`}{`\\`}{`\\`}{`$15/kg for extra`}</em></p>
    <p>{`Ugh, okay, fine. Whatever.`}</p>
    <p><em parentName="p">{`"You can do an extra bag for `}{`\\`}{`\\`}{`\\`}{`$100"`}</em></p>
    <p>{`Yeah, but I don't have an extra bag, do I?`}</p>
    <p><em parentName="p">{`"Very well then. That will be `}{`\\`}{`\\`}{`\\`}{`$105."`}</em></p>
    <p>{`k`}</p>
    <p><em parentName="p">{`"And you're flying to Paris, is that correct, sir?"`}</em></p>
    <p>{`Erm, actually it's to Ljubljana. But I bought my tickets separately. Is there any way you can check my bag through to final destination?`}</p>
    <p><em parentName="p">{`"We can't do that. You'll have to pick the bags up at the airport.”`}</em></p>
    <p>{`But my next flight is an hour after this one lands because of the delay.`}</p>
    <p><em parentName="p">{`"Sorry, sir. Nothing we can do"`}</em></p>
    <p>{`:`}{`|`}</p>
    <p>{`-`}{`- Oakland, 2:38pm`}</p>
    <p>{`Made it to the gate 13 whole minutes before boarding starts!`}</p>
    <blockquote {...{
      "className": "twitter-tweet",
      "data-dnt": "true"
    }}><p parentName="blockquote" {...{
        "lang": "en",
        "dir": "ltr"
      }}>{`Boom 💥 at gate 13min before boarding even starts`}<br parentName="p"></br><br parentName="p"></br>{`Liiiiiike a glove`}</p>{`— Swizec Teller published ServerlessHandbook.dev (@Swizec) `}<a parentName="blockquote" {...{
        "href": "https://twitter.com/Swizec/status/1073346405429796864"
      }}>{`December 13, 2018`}</a></blockquote>
    <p>{`-`}{`- Oakland, 2:40pm`}</p>
    <p>{`I'm bored. I came too early.`}</p>
    <p>{`-`}{`- Oakland, 2:41pm`}</p>
    <p><em parentName="p">{`Announcement Norwegian flight 7080 to Paris CDG is boarding at Gate 8, NOT Gate 3 as originally announced. Expect boarding in about 40 minutes`}</em></p>
    <p>{`Wait … shit. I'm missing my flight from Paris. There's no way we're making this. If we're leaving 40 minutes later than the already late departure, that means we land 30min after my flight leaves.`}</p>
    <p>{`Noooooooooooo`}</p>
    <p>{`-`}{`- Oakland, 2:50pm`}</p>
    <p>{`Mom, I think I'm gonna miss it. No, I'm not sure what else to do. Next flight is a day later. No, tickets to nearby airports are like $400.`}</p>
    <p>{`I dunno. I'll let you know when I get there.`}</p>
    <p>{`-`}{`- Oakland, 3:35pm`}</p>
    <p>{`A drunk Norwegian fellow waiting for my flight gets escorted out of the airport.`}</p>
    <p>{`¯`}{`\\`}{`_`}{`(ツ)`}{`_`}{`/¯`}</p>
    <p>{`-`}{`- Oakland, 4:20pm`}</p>
    <p>{`Yaaay, we're boarding.`}</p>
    <p>{`-`}{`- Oakland, 4:25pm`}</p>
    <p>{`Why aren't we leaving!? Why is everyone taking so long? Why is an entire Boeing Dreamliner worth of people conspiring against me just to make me miss my flight. MOVE FASTER.`}</p>
    <p>{`-`}{`- Oakland, 4:50pm`}</p>
    <p>{`Takeoff.`}</p>
    <p>{`It's weird knowing you've missed your flight 13 hours before it happens.`}</p>
    <p>{`-`}{`- Flight 7080, 5:30pm…`}</p>
    <p>{`Oh great. My neighbor is one of `}<em parentName="p">{`those people`}</em>{`. Tweed jacket on a flight. Mildly disgusted look on his face. Reading high brow geopolitical magazines titled `}<em parentName="p">{`Do nuclear weapons matter?`}</em>{`. Complains about every little thing.`}</p>
    <p>{`He doesn't just throw away half his lunch. He also loudly complains. Takes a bite of his chocolate muffin. `}<em parentName="p">{`"Ew this is disgusting!"`}</em>{`. Puts it down.`}</p>
    <p>{`ITS AN AIRPLANE MUFFIN WHAT DID YOU EXPECT`}</p>
    <p>{`-`}{`- Paris, 11:50am`}</p>
    <p>{`We did it! The Dreamliner landed before my next flight!`}</p>
    <blockquote {...{
      "className": "twitter-tweet",
      "data-dnt": "true"
    }}><p parentName="blockquote" {...{
        "lang": "en",
        "dir": "ltr"
      }}>{`Ok landed in Paris. Got 50min to finish taxiing, go get lugagge at baggage claim, go back through security, and make my next flight.`}<br parentName="p"></br><br parentName="p"></br>{`🤞 `}<a parentName="p" {...{
          "href": "https://t.co/7NkVTUVpi4"
        }}>{`pic.twitter.com/7NkVTUVpi4`}</a></p>{`— Swizec Teller published ServerlessHandbook.dev (@Swizec) `}<a parentName="blockquote" {...{
        "href": "https://twitter.com/Swizec/status/1073530651935150081"
      }}>{`December 14, 2018`}</a></blockquote>
    <p>{`50 minutes to: Get off the plane. Pick up my bags. Go to my terminal. Go back through security. Run to the gate. Board the plane.`}</p>
    <p>{`TAXI FASTER WHY IS THIS TAKING SO LONG`}</p>
    <p>{`-`}{`- Paris, 11:55pm`}</p>
    <p>{`WHY IS EVERYONE JUST STANDING THERE MOVE PEOPLE`}</p>
    <p>{`-`}{`- Paris, 12:00pm`}</p>
    <p>{`WHERE THE HELL ARE WE WHY ISN’T THERE A GATE GANGPLANK THING WHAT WE HAVE TO TAKE A BUS TO THE TERMINAL I AM DOOMED`}</p>
    <p>{`Shit, it's cold too. 1 Celsius.`}</p>
    <p>{`-`}{`- Paris, 12:05pm`}</p>
    <p>{`WHY IS THIS CORRIDOR SO LONG WHY IS THIS AIRPORT SO CONFUSING WHY DOES EVERYTHING SUCK TODAY`}</p>
    <p>{`-`}{`- Paris, 12:15pm`}</p>
    <p>{`It's done. I'm doomed. I stand here waiting for my bags and my bags aren't showing up and boarding starts in 25 minutes and I'm doomed and there's nothing I can do.`}</p>
    <p>{`-`}{`- Paris, 12:20pm`}</p>
    <p>{`GOT MY BAGS RUN FOREST RUN`}</p>
    <p>{`-`}{`- Paris, 12:23pm`}</p>
    <p>{`Holy shit passport control. Can the universe possibly put any more obstacles in my way?!`}</p>
    <p>{`The cute border agent smiled at me though, so that's a win.`}</p>
    <p>{`-`}{`- Paris, 12:30pm`}</p>
    <p>{`WHAT I HAVE TO TAKE A TRAIN TO MY TERMINAL`}</p>
    <p>{`Oh good the train's already here.`}</p>
    <p>{`-`}{`- Paris, 12:35pm`}</p>
    <p>{`Oh `}<em parentName="p">{`come on`}</em>{` Terminal 2 is aaaaall the way on the opposite side of the airport!? Literally all the stops away??`}</p>
    <p>{`-`}{`- Paris, 12:40pm`}</p>
    <p>{`Made it to Terminal 2. We got dis! Where is 2G. Run run run`}</p>
    <p>{`-`}{`- Paris, 12:45pm`}</p>
    <p>{`WHAT I HAVE TO TAKE A BUS TO G`}</p>
    <p>{`Oh good bus is here already`}</p>
    <p>{`-`}{`- Paris, 12:50pm`}</p>
    <p>{`Bye bye flight. Missed it. Departure at 12:50pm and here I am stuck on an airport bus that isn't moving. What the hell are we waiting for?`}</p>
    <blockquote {...{
      "className": "twitter-tweet",
      "data-dnt": "true"
    }}><p parentName="blockquote" {...{
        "lang": "en",
        "dir": "ltr"
      }}>{`Flight just left unless there is delay and I’m on the last bus thing to the right terminal `}<a parentName="p" {...{
          "href": "https://t.co/FP8We2C6yf"
        }}>{`pic.twitter.com/FP8We2C6yf`}</a></p>{`— Swizec Teller published ServerlessHandbook.dev (@Swizec) `}<a parentName="blockquote" {...{
        "href": "https://twitter.com/Swizec/status/1073546255090020354"
      }}>{`December 14, 2018`}</a></blockquote>
    <p>{`-`}{`- 2G, 12:58pm`}</p>
    <p><em parentName="p">{`"Bonjour monsieur"`}</em></p>
    <p>{`Bonjour. Yeah I think I missed my flight. Previous flight had a delay.`}</p>
    <p><em parentName="p">{`"Oh that is terrible monsieur. What airline?"`}</em></p>
    <p>{`Norwegian.`}</p>
    <p><em parentName="p">{`"Oh, but this is not the same contract you see"`}</em></p>
    <p>{`I know. Is there anything you can do though? Other flights? Options?`}</p>
    <p><em parentName="p">{`"Monsieur, you will have to go to the ticketing office to change your flight. We are baggage drop-off"`}</em></p>
    <p>{`Whe…`}</p>
    <p><em parentName="p">{`"The Ljubljana flight, you say? You are in luck! It is delayed. They leave at 1:40pm."`}</em></p>
    <p>{`What seriously!? I made it!?`}</p>
    <p><em parentName="p">{`"Go to my colleague over there. Hurry, sir.”`}</em></p>
    <p>{`Bonjour.`}</p>
    <p><em parentName="p">{`"Sir your bag is too heavy"`}</em></p>
    <p>{`Err ... does it count if I already paid the other airline for it? `}<em parentName="p">{`awkward smile`}</em></p>
    <p><em parentName="p">{`shakes head`}</em></p>
    <p>{`Sigh, then I guess what can I do ...`}</p>
    <p><em parentName="p">{`"You can also take 2 kilos out of your bag and take them with you. But hurry."`}</em></p>
    <p>{`Nowhere to put them. I'll just pay.`}</p>
    <p>{`-`}{`- 2G, 1:20pm`}</p>
    <p>{`Mum yah I made the flight! Come pick me up at the airport around 3:30pm.`}</p>
    <blockquote {...{
      "className": "twitter-tweet",
      "data-dnt": "true"
    }}><p parentName="blockquote" {...{
        "lang": "en",
        "dir": "ltr"
      }}>{`Yessssssthis flight is delayed too so I totally made it!`}<br parentName="p"></br><br parentName="p"></br>{`Never give up. It ain’t over until the fat lady sings 🤘🏼 `}<a parentName="p" {...{
          "href": "https://t.co/NkXgoUIlsJ"
        }}>{`pic.twitter.com/NkXgoUIlsJ`}</a></p>{`— Swizec Teller published ServerlessHandbook.dev (@Swizec) `}<a parentName="blockquote" {...{
        "href": "https://twitter.com/Swizec/status/1073552056714256384"
      }}>{`December 14, 2018`}</a></blockquote>
    <hr></hr>
    <p>{`Never give up. It ain't over until it's over.`}</p>
    <p>{`Remember the song.`}</p>
    <lite-youtube {...{
      "videoid": "oKsxPW6i3pM",
      "videostartat": "0"
    }}></lite-youtube>
    <p>{`A sensible person would change their flight. A sensible person would go straight to ticketing after landing. A sensible person wouldn't have made this flight.`}</p>
    <p>{`Don't be a sensible person. Be a lucky person instead.`}</p>
    <p>{`😘`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      